module.exports = __webpack_public_path__ + "fa9125dea242bce93a13bb0c5ec1ce4f.svg";